import '../styles/components/DurationPicker.css'
import {FilterOption, SearchFilters} from "../types/travel.ts";

interface DurationPickerProps {
    options: FilterOption[]
    selectedValues?: string[]
    onDurationChange: (category: keyof SearchFilters, value: string, checked: boolean) => void
    title?: string
}

export function DurationPicker({
                                   options,
                                   selectedValues,
                                   onDurationChange,
                                   title = "Reisedauer (Tage)"
                               }: DurationPickerProps) {

    const handleOptionClick = (value: string, checked: boolean) => {
        // Toggle selection - if already selected, deselect it
        onDurationChange('duration', value, checked)
    }

    return (
        <div className="aside-section duration-picker-container">
            <h3 className="duration-picker-title">{title}</h3>
            <div className="duration-picker-options">
                {options.map(option => (
                    <button
                        key={option.value}
                        onClick={() => handleOptionClick(option.value, !(selectedValues || []).includes(option.value))}
                        className={`duration-picker-option ${
                            selectedValues?.includes(option.value)
                                ? 'duration-picker-option--selected'
                                : 'duration-picker-option--unselected'
                        }`}
                    >
                        <span className="duration-picker-option-text">{option.label}</span>
                    </button>
                ))}
            </div>
        </div>
    )
}
